import React, { useEffect, useState } from 'react';
import { Paper } from 'library';
import CommunityRepresentative from './CommunityRepresentative';
import UserAttributesApi from 'shared/UserAttributesApi';

export default function CommunityRepresentativeCard() {
    const [show, setShow] = useState<boolean>(true);

    async function checkCommunityRepresenative() {
        const notInterested = await UserAttributesApi.exists('Community Representative Not Interested');
        const interested = await UserAttributesApi.exists('Community Representative Interested');
        return notInterested || interested ? false : true;
    }

    useEffect(() => {
        showSection();
    }, []);

    async function showSection() {
        if (await checkCommunityRepresenative()) {
            setShow(false);
        }
    }

    return (
        <>
            {!show ? null : (
                <Paper style={{ marginBottom: 50 }}>
                    <CommunityRepresentative />
                </Paper>
            )}
        </>
    );
}
